module.exports = __webpack_public_path__ + "static/media/ettv-logo.d6f99275.png";